import { render, staticRenderFns } from "./menuProcessus.vue?vue&type=template&id=c2c560ae&scoped=true&"
import script from "./menuProcessus.vue?vue&type=script&lang=js&"
export * from "./menuProcessus.vue?vue&type=script&lang=js&"
import style0 from "./menuProcessus.vue?vue&type=style&index=0&id=c2c560ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c560ae",
  null
  
)

export default component.exports